import { render, staticRenderFns } from "./DSOrganisationFields.vue?vue&type=template&id=63048de3&"
import script from "./DSOrganisationFields.vue?vue&type=script&lang=js&"
export * from "./DSOrganisationFields.vue?vue&type=script&lang=js&"
import style0 from "./DSOrganisationFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports